// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientInfo {
    static getAttributeTypeMap() {
        return MangoHubGetPatientInfo.attributeTypeMap;
    }
}
MangoHubGetPatientInfo.discriminator = undefined;
MangoHubGetPatientInfo.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "hasPatientConsent",
        "baseName": "hasPatientConsent",
        "type": "boolean"
    }
];
//# sourceMappingURL=mangoHubGetPatientInfo.js.map